import { all, put, fork, takeEvery, select, take, delay, call } from 'redux-saga/effects';
import { get, post, PUT, DELETE } from '@iso/lib/helpers/resApiRequestor';
import actions from './actions';
import mqttActions from '../mqtt/actions';
import { MQTT_MODULE } from '@iso/containers/constants';

export function* addReconciliationMIDSetting() {
  yield takeEvery(actions.ADD_RECONCILIATION_MID_SETTING, function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_RECONCILIATION_MID_SETTING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addReconciliationMIDSettingAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_RECONCILIATION_MID_SETTING_SUCCESS,
          loading: false,
          message: result.message,
          result: result?.data
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_RECONCILIATION_MID_SETTING_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_RECONCILIATION_MID_SETTING_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_RECONCILIATION_MID_SETTING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchReconciliationMIDSettings() {
  yield takeEvery(actions.FETCH_RECONCILIATION_MID_SETTINGS, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_RECONCILIATION_MID_SETTINGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchReconciliationMIDSettingsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const finalData = result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_RECONCILIATION_MID_SETTINGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result?.pagination
        });
      } else {
        yield put({
          type: actions.FETCH_RECONCILIATION_MID_SETTINGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_RECONCILIATION_MID_SETTINGS_FAILED,
        loading: false
      });
    }
  });
}

export function* updateReconciliationMIDSetting() {
  yield takeEvery(actions.UPDATE_RECONCILIATION_MID_SETTING, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_RECONCILIATION_MID_SETTING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      const apiResult = yield updateReconciliationMIDSettingAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPDATE_RECONCILIATION_MID_SETTING_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data
        });
      } else {
        yield put({
          type: actions.UPDATE_RECONCILIATION_MID_SETTING_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_RECONCILIATION_MID_SETTING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchPaymentChannelReportsData() {
  yield takeEvery('FETCH_PAYMENT_CHANNEL_REPORTS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PAYMENT_CHANNEL_REPORTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPaymentChannelReportsAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      const pagination = result.pagination;
      const data = result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PAYMENT_CHANNEL_REPORTS_SUCCESS,
          pagination,
          filter: payload,
          payload: data,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_PAYMENT_CHANNEL_REPORTS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_PAYMENT_CHANNEL_REPORTS_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PAYMENT_CHANNEL_REPORTS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchPaymentChannelRecord() {
  yield takeEvery('FETCH_PAYMENT_CHANNEL_RECORDS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PAYMENT_CHANNEL_RECORDS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPchannelRecordAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      const pagination = result.pagination;
      const data = result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PAYMENT_CHANNEL_RECORDS_SUCCESS,
          pagination,
          summary: result.summary,
          filter: payload,
          payload: data,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_PAYMENT_CHANNEL_RECORDS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_PAYMENT_CHANNEL_RECORDS_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PAYMENT_CHANNEL_RECORDS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchFloatingTrx() {
  yield takeEvery('FETCH_FLOATING_RECORDS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_FLOATING_RECORDS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPchannelRecordAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      const pagination = result.pagination;
      const data = result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_FLOATING_RECORDS_SUCCESS,
          pagination,
          summary: result.summary,
          filter: payload,
          payload: data,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_FLOATING_RECORDS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_FLOATING_RECORDS_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FLOATING_RECORDS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchPossibleMatchList() {
  yield takeEvery('FETCH_POSSIBLE_MATCH_LIST', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_POSSIBLE_MATCH_LIST,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPossibleMatchListAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      const data = result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_POSSIBLE_MATCH_LIST_SUCCESS,
          filter: payload,
          payload: data,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_POSSIBLE_MATCH_LIST_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_POSSIBLE_MATCH_LIST_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_POSSIBLE_MATCH_LIST_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* matchManualTrx() {
  yield takeEvery('MATCH_MANUAL_TRX', function* ({ payload }) {
    try {
      yield put({
        type: actions.MATCHING_MANUAL_TRX,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield matchManualTrxAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.MATCH_MANUAL_TRX_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.MATCH_MANUAL_TRX_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.MATCH_MANUAL_TRX_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.MATCH_MANUAL_TRX_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* manualReconcileTrx() {
  yield takeEvery(actions.MANUAL_RECONCILE_TRX, function* ({ payload }) {
    try {
      yield put({
        type: actions.MANUAL_RECONCILE_TRX_LOADING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield manualReconcileTrxAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.MANUAL_RECONCILE_TRX_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.MANUAL_RECONCILE_TRX_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.MANUAL_RECONCILE_TRX_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.MANUAL_RECONCILE_TRX_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* ammendTrxFloating() {
  yield takeEvery('AMMEND_MANUAL_TRX', function* ({ payload }) {
    try {
      yield put({
        type: actions.AMMENDING_MANUAL_TRX,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield ammendManualTrxAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.AMMEND_MANUAL_TRX_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.AMMEND_MANUAL_TRX_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.AMMEND_MANUAL_TRX_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.AMMEND_MANUAL_TRX_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* processReconFileAction() {
  yield takeEvery('PROCESS_RECON_FILE_ACTION', function* ({ payload }) {
    try {
      yield put({
        type: actions.PROCESSING_RECON_FILE_ACTION,
        loading: true
      });
      const state = yield select();
      const reconFilesFilter = state.Finance.reconFilesFilter;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield processReconFileActionAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.PROCESS_RECON_FILE_ACTION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_RECON_FILES,
          payload: reconFilesFilter
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.PROCESS_RECON_FILE_ACTION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.PROCESS_RECON_FILE_ACTION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.PROCESS_RECON_FILE_ACTION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchResourceRecord() {
  yield takeEvery('FETCH_RESOURCE_RECORDS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_RESOURCE_RECORDS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchResourceRecordAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      const pagination = result.pagination;
      const data = result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_RESOURCE_RECORDS_SUCCESS,
          pagination,
          summary: result.summary,
          filter: payload,
          payload: data,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_RESOURCE_RECORDS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_RESOURCE_RECORDS_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_RESOURCE_RECORDS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchL2DependencyRecord() {
  yield takeEvery('FETCH_HAS_L2_DEPENDENCY_RECORDS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_HAS_L2_DEPENDENCY_RECORDS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchL2DependencyRecordAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      const data = result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_HAS_L2_DEPENDENCY_RECORDS_SUCCESS,
          filter: payload,
          payload: data,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_HAS_L2_DEPENDENCY_RECORDS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_HAS_L2_DEPENDENCY_RECORDS_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_HAS_L2_DEPENDENCY_RECORDS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* handleUploadFiles() {
  yield takeEvery('UPLOAD_RECON_FILE', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPLOADING_RECON_FILE,
        loading: true
      });
      const files = payload.files;
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const reconFilter = state.Finance.pchannelRecordFilter ?? null;

      if (reconFilter && (!reconFilter.from || !reconFilter.to)) {
        yield put({
          type: actions.UPLOAD_RECON_FILE_FAILED,
          loading: false,
          message: 'Transaction date is required'
        });
      }

      let getUrlRequest = {
        from: reconFilter.from,
        to: reconFilter.to,
        payment_channel: payload.payment_channel,
        template_id: payload.template_id,
        files: files.map(file => ({ name: file.name }))
      };

      const response = yield getUploadUrl(getUrlRequest, roleHeaderAuth);
      const apiResult = response.data;
      if (apiResult && !apiResult.success) {
        yield put({
          type: actions.UPLOAD_RECON_FILE_FAILED,
          loading: false,
          message: response.message
        });

        return;
      }
      const presignedUrls = apiResult.data;

      // Upload all files in parallel
      yield all(
        presignedUrls
          .map(p => {
            const fileToUpload = files.find(f => f.name === p.name);
            if (!fileToUpload) return null;
            return call(uploadToS3, p.url, fileToUpload);
          })
          .filter(Boolean) // remove nulls
      );

      // Call parse endpoint with all keys
      const keys = presignedUrls.map(p => p.key);
      const parseRequest = {
        ...reconFilter,
        topic: `/parse/reconciliation/${process.env.REACT_APP_ENVIRONMENT}/${payload.payment_channel}/${payload.template_id}`,
        module: MQTT_MODULE.PARSE_RECONCILE_FILE,
        keys
      };
      yield put({
        type: mqttActions.CONNECT_MQTT,
        payload: parseRequest
      });
      yield call(parseFiles, parseRequest, roleHeaderAuth);

      yield put({
        type: actions.UPLOAD_RECON_FILE_SUCCESS,
        loading: false,
        message: 'File uploaded successfully. Parsing is ongoing...'
      });
    } catch (err) {
      yield put({
        type: actions.UPLOAD_RECON_FILE_FAILED,
        loading: false,
        message: 'File failed to upload'
      });
    }
  });
}

export function* fetchReconFiles() {
  yield takeEvery('FETCH_RECON_FILES', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_RECON_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchReconFilesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      const pagination = result.pagination;
      const data = result.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      if (result.success) {
        yield put({
          type: actions.FETCH_RECON_FILES_SUCCESS,
          pagination,
          filter: payload,
          payload: data,
          loading: false
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_RECON_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_RECON_FILES_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_RECON_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchReportFiles() {
  yield takeEvery('FETCH_REPORT_FILES', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_REPORT_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchReportFilesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      const pagination = result.pagination;
      const data = result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_REPORT_FILES_SUCCESS,
          pagination,
          filter: payload,
          payload: data,
          loading: false
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_REPORT_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_REPORT_FILES_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_REPORT_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateReportData() {
  yield takeEvery('GENERATE_RECON_REPORT', function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_RECON_REPORT,
        loading: true
      });
      const state = yield select();
      const reportFilesFilter = state.Finance.reportFilesFilter;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateReportDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: mqttActions.CONNECT_MQTT,
          payload: payload
        });
        yield put({
          type: actions.GENERATE_RECON_REPORT_SUCCESS,
          loading: false,
          message: 'Generating reconciled report. Please wait...'
        });
        console.log('REPORT_FILER', reportFilesFilter);
        yield put({
          type: actions.FETCH_REPORT_FILES,
          payload: reportFilesFilter
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_RECON_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_RECON_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_RECON_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadReconReport() {
  yield takeEvery('DOWNLOAD_RECONCILIATION_REPORT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_RECONCILIATION_REPORT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadReconFileAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_RECONCILIATION_REPORT_DATA_SUCCESS,
          loading: false,
          message: 'Report downloaded successfully.'
        });

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_RECONCILIATION_REPORT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_RECONCILIATION_REPORT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_RECONCILIATION_REPORT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchFilesFromPchannelReports() {
  yield takeEvery('FETCH_FILE_FROM_PCHANNEL_REPORTS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_FILE_FROM_PCHANNEL_REPORTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchFilesFromPchannelReportsAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      const data = result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_FILE_FROM_PCHANNEL_REPORTS_SUCCESS,
          payload: data,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_FILE_FROM_PCHANNEL_REPORTS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_FILE_FROM_PCHANNEL_REPORTS_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FILE_FROM_PCHANNEL_REPORTS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllRemittanceTemplatesFromPchannel() {
  yield takeEvery(actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllRemittanceTemplatesFromPchannelAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addRemittanceTemplateFromPchannel() {
  yield takeEvery(actions.ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL, function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addRemittanceTemplateFromPchannelAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        if (payload && payload?.payment_channel) {
          yield put({
            type: actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
            payload: { payment_channel: payload?.payment_channel }
          });
        }
      } else {
        yield put({
          type: actions.ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editRemittanceTemplateFromPchannel() {
  yield takeEvery(actions.EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL, function* ({ payload }) {
    try {
      yield put({
        type: actions.EDITING_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editRemittanceTemplateFromPchannelAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        if (payload && payload?.payment_channel) {
          yield put({
            type: actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
            payload: { payment_channel: payload?.payment_channel }
          });
        }
      } else {
        yield put({
          type: actions.EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* toggleStatusRemittanceTemplateFromPchannel() {
  yield takeEvery(actions.TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL, function* ({ payload }) {
    try {
      yield put({
        type: actions.TOGGLING_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield toggleStatusRemittanceTemplateFromPchannelAPI(
        payload,
        roleHeaderAuth
      );
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        if (payload && payload?.payment_channel) {
          yield put({
            type: actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL,
            payload: { payment_channel: payload?.payment_channel }
          });
        }
      } else {
        yield put({
          type: actions.TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* uploadMultipleFileDataRemittance() {
  yield takeEvery(
    actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE,
    function* ({ urls, payload, pagination }) {
      try {
        yield put({
          type: actions.UPLOADING_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE,
          loading: true
        });

        yield put({
          type: mqttActions.CONNECT_MQTT,
          payload: payload
        });

        const event = yield take([mqttActions.CONNECT_SUCCESS]);

        if (event.type !== mqttActions.CONNECT_SUCCESS) {
          yield put({
            type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED,
            message: 'Failed to process request',
            loading: false
          });
        }

        const roleHeaderAuth = yield getRoleHeader();
        const state = yield select();
        const uploadedChannel = state.Finance.uploadedChannel;
        if (payload && payload.files.length === urls.length) {
          // let finalDataForUpload = processUploadingMultipleFiles(payload, urls);
          let finalDataForUpload = [];
          const dataFile = payload.files;

          // Track upload promises
          const uploadPromises = dataFile.map(async file => {
            // Check if the file has a corresponding URL
            const getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              try {
                // Upload file to S3 with progress monitoring
                await uploadFileToS3WithProgress(getURL, file, progress => {});

                // After upload, add metadata to the final data
                finalDataForUpload.push({
                  template_id: payload.template_id,
                  name: file.name,
                  module: payload.module,
                  topic: payload.topic
                });
              } catch (error) {
                console.error(`Error uploading file ${file.name}:`, error.message);
              }
            }
          });

          // Wait for all uploads to complete
          yield Promise.all(uploadPromises);

          if (finalDataForUpload && finalDataForUpload.length > 0) {
            const apiResult = yield uploadMultipleFileDataRemittanceAPI(
              {
                files: finalDataForUpload,
                template_id: payload.template_id,
                file_password: payload.file_password,
                name: payload.name,
                module: payload.module,
                topic: payload.topic,
                notification_data: payload.notification_data,
                bank_template_id: payload?.bank_template_id,
                trx_date: payload?.trx_date,
                file: payload?.file
              },
              roleHeaderAuth
            );
            const result = apiResult.data;
            if (result.success) {
              yield put({
                type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_SUCCESS,
                loading: false,
                message: result.message
              });
              yield put({
                type: actions.FETCH_UPLOADED_FILES_REMITTANCE,
                payload: uploadedChannel
              });
            } else {
              if (result.status === 404) {
                yield put({
                  type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED,
                  message: `Endpoint ${result.title}`,
                  loading: false
                });
              } else if (result.status === 413) {
                yield put({
                  type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED,
                  message: `Your request exceeded the system limit size`,
                  loading: false
                });
              } else {
                yield put({
                  type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED,
                  message: result.message,
                  loading: false
                });
              }
            }
          } else {
            yield put({
              type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED,
              message: `Files were failed to upload due to an connection issue. Please try again.`,
              loading: false
            });
          }
        } else {
          yield put({
            type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED,
            message: 'Failed to upload multiple files at the same time. Please try again.',
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    }
  );
}

export function* fetchAllUploadedFilesRemittance() {
  yield takeEvery(actions.FETCH_UPLOADED_FILES_REMITTANCE, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_UPLOADED_FILES_REMITTANCE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllUploadedFilesRemittanceAPI(
        payload,
        pagination,
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_UPLOADED_FILES_REMITTANCE_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          pagination: result ? result.pagination : null,
          channel: payload
        });
      } else {
        yield put({
          type: actions.FETCH_UPLOADED_FILES_REMITTANCE_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UPLOADED_FILES_REMITTANCE_FAILED,
        loading: false
      });
    }
  });
}

function fetchAllUploadedFilesRemittanceAPI(data, pagination, roleAuth) {
  return post(`get-all/remittance/upload-file`, data, pagination, null, roleAuth);
}

export function* fetchRemittanceUploadedPchannelData() {
  yield takeEvery(
    actions.FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_REMITTANCE_UPLOADED_PCHANNEL_DATA,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchRemittanceUploadedPchannelDataAPI(
          { ...payload },
          pagination,
          roleHeaderAuth
        );
        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA_SUCCESS,
            loading: false,
            message: result.message,
            result: result ? result.data : null,
            pagination: result.pagination ? result.pagination : null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    }
  );
}

export function* fetchRemittanceLogs() {
  yield takeEvery(actions.FETCH_REMITTANCE_LOGS_FROM_PCHANNEL, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_REMITTANCE_LOGS_FROM_PCHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchRemittanceLogsAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_SUCCESS,
          loading: false,
          result: result.data[0] ? result.data[0] : null,
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        if (result === '404') {
          yield put({
            type: actions.FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_FAILED,
            loading: false,
            message: `Endpoint ${result.title}`
          });
        } else {
          yield put({
            type: actions.FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_FAILED,
            loading: false,
            message: result.message ? result.message : 'No payment channel log found'
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchFinanceDashboardPchannelData() {
  yield takeEvery(
    actions.FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_FINANCE_DASHBOARD_PCHANNEL_DATA,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchFinanceDashboardPchannelDataAPI(
          payload,
          pagination,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_SUCCESS,
            loading: false,
            result: result.data,
            pagination: result.pagination,
            filter: payload
          });
        } else {
          if (result.status === 404) {
            yield put({
              type: actions.FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_FAILED,
              message: `Endpoint ${result.title}`,
              loading: false,
              result: null,
              filter: payload
            });
          } else {
            yield put({
              type: actions.FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_FAILED,
              message: 'Failed to process request',
              loading: false,
              result: null,
              filter: payload
            });
          }
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_FAILED,
          loading: false,
          message: 'Failed to process request',
          result: null,
          filter: payload
        });
      }
    }
  );
}

export function* deleteRemittanceFileAndTransactions() {
  yield takeEvery(
    actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.DELETING_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield deleteRemittanceFileAndTransactionsAPI(
          payload?.uploaded_file_id,
          roleHeaderAuth
        );

        const result = apiResult.data;
        if (result.success) {
          yield put({
            type: actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_SUCCESS,
            loading: false,
            message: result.message
          });
          if (payload?.payment_channel_id) {
            yield put({
              type: actions.FETCH_UPLOADED_FILES_REMITTANCE,
              payload: { payment_channel_id: payload?.payment_channel_id }
            });
          }
        } else {
          yield put({
            type: actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_FAILED,
            message: result.message,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    }
  );
}

export function* generateSettlementSummaryReport() {
  yield takeEvery(actions.GENERATE_SETTLEMENT_SUMMARY_REPORT, function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_SETTLEMENT_SUMMARY_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateSettlementSummaryReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_SETTLEMENT_SUMMARY_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA,
          payload: {},
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_SETTLEMENT_SUMMARY_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_SETTLEMENT_SUMMARY_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_SETTLEMENT_SUMMARY_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadSettlementSummaryReport() {
  yield takeEvery(actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT, function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_SETTLEMENT_SUMMARY_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadSettlementSummaryReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SUCCESS,
          loading: false,
          message: 'Settlement summary report downloaded successfully.'
        });

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchSettlementSummaryReportData() {
  yield takeEvery(
    actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_SETTLEMENT_SUMMARY_REPORT_DATA,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchSettlementSummaryReportDataAPI(
          payload,
          pagination,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED,
          loading: false
        });
      }
    }
  );
}

export function* approveSettlementSummaryReport() {
  yield takeEvery(actions.APPROVE_SETTLEMENT_SUMMARY_REPORT, function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.APPROVING_SETTLEMENT_SUMMARY_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let eSignature = [];
      if (
        payload &&
        payload.e_signature &&
        urls &&
        urls.e_signature &&
        payload.e_signature.length === urls.e_signature.length
      ) {
        const dataFile = payload.e_signature;
        dataFile.forEach(file => {
          if (urls.e_signature.some(str => str.includes(file.name))) {
            let getURL = urls.e_signature.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              eSignature.push(currentObj);
            }
          }
        });

        yield delay(urls.e_signature.length * 1000);
      }

      const apiResult = yield approveSettlementSummaryReportAPI(
        { ...payload, e_signature: eSignature },
        roleHeaderAuth
      );

      const result = apiResult.data;

      const state = yield select();
      const pagination = state.Finance.settlementSummaryReportFileDataPagination ?? {
        page: 0,
        limit: 20
      };
      const filter = state.Finance.settlementSummaryReportFileDataFilter ?? {};

      if (result.success) {
        yield put({
          type: actions.APPROVE_SETTLEMENT_SUMMARY_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA,
          payload: filter,
          pagination: pagination
        });
      } else {
        yield put({
          type: actions.APPROVE_SETTLEMENT_SUMMARY_REPORT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_SETTLEMENT_SUMMARY_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* requestReviewSettlementSummaryReport() {
  yield takeEvery(actions.REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT, function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.REQUESTING_REVIEW_SETTLEMENT_SUMMARY_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let eSignature = [];
      if (
        payload &&
        payload.e_signature &&
        urls &&
        urls.e_signature &&
        payload.e_signature.length === urls.e_signature.length
      ) {
        const dataFile = payload.e_signature;
        dataFile.forEach(file => {
          if (urls.e_signature.some(str => str.includes(file.name))) {
            let getURL = urls.e_signature.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              eSignature.push(currentObj);
            }
          }
        });

        yield delay(urls.e_signature.length * 1000);
      }

      const apiResult = yield requestReviewSettlementReportAPI(
        { ...payload, e_signature: eSignature },
        roleHeaderAuth
      );

      const result = apiResult.data;

      const state = yield select();
      const pagination = state.Finance.settlementSummaryReportFileDataPagination ?? {
        page: 0,
        limit: 20
      };
      const filter = state.Finance.settlementSummaryReportFileDataFilter ?? {};

      if (result.success) {
        yield put({
          type: actions.REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA,
          payload: filter,
          pagination: pagination
        });
      } else {
        yield put({
          type: actions.REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectSettlementSummaryReport() {
  yield takeEvery(actions.REJECT_SETTLEMENT_SUMMARY_REPORT, function* ({ payload }) {
    try {
      yield put({
        type: actions.REJECTING_SETTLEMENT_SUMMARY_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectSettlementSummaryReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const state = yield select();
      const pagination = state.Finance.settlementSummaryReportFileDataPagination ?? {
        page: 0,
        limit: 20
      };
      const filter = state.Finance.settlementSummaryReportFileDataFilter ?? {};

      if (result.success) {
        yield put({
          type: actions.REJECT_SETTLEMENT_SUMMARY_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA,
          payload: filter,
          pagination: pagination
        });
      } else {
        yield put({
          type: actions.REJECT_SETTLEMENT_SUMMARY_REPORT_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_SETTLEMENT_SUMMARY_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateSummaryBreakdownReportRemittance() {
  yield takeEvery(actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE, function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_SUMMARY_BREAKDOWN_REPORT_REMITTANCE,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateSummaryBreakdownReportRemittanceAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllGeneratedRemittanceSummaryReportData() {
  yield takeEvery(
    actions.FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchAllGeneratedRemittanceSummaryReportDataAPI(
          payload,
          pagination,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA_FAILED,
          loading: false
        });
      }
    }
  );
}

export function* downloadRemittanceSummaryReport() {
  yield takeEvery(actions.DOWNLOAD_REMITTANCE_SUMMARY_REPORT, function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_REMITTANCE_SUMMARY_REPORT,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadRemittanceSummaryReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_REMITTANCE_SUMMARY_REPORT_SUCCESS,
          loading: false,
          message: 'Remittance summary report downloaded successfully.'
        });

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_REMITTANCE_SUMMARY_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_REMITTANCE_SUMMARY_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_REMITTANCE_SUMMARY_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* deleteRemittanceSummaryReport() {
  yield takeEvery(
    actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.DELETING_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield deleteRemittanceSummaryReportAPI(
          payload?.uploaded_file_id,
          roleHeaderAuth
        );

        const result = apiResult.data;
        if (result.success) {
          yield put({
            type: actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_SUCCESS,
            loading: false,
            message: result.message
          });
          if (payload?.payment_channel_id) {
            yield put({
              type: actions.FETCH_UPLOADED_FILES_REMITTANCE,
              payload: { payment_channel_id: payload?.payment_channel_id }
            });
          }
        } else {
          yield put({
            type: actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_FAILED,
            message: result.message,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    }
  );
}

export function* downloadUploadedFileRemittance() {
  yield takeEvery(actions.DOWNLOAD_UPLOADED_FILE_REMITTANCE, function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_UPLOADED_FILE_REMITTANCE,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadUploadedFileRemittanceAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_UPLOADED_FILE_REMITTANCE_SUCCESS,
          loading: false,
          message: result.message
        });

        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_UPLOADED_FILE_REMITTANCE_FAILED,
            message: `Endpoint: ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_UPLOADED_FILE_REMITTANCE_FAILED,
            message: result.message
              ? result.message
              : 'Failed to download uploaded file remittance',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_UPLOADED_FILE_REMITTANCE_FAILED,
        message: 'Failed to download uploaded file remittance',
        loading: false
      });
    }
  });
}

export function* fetchGeneratedPaymentChannelDiscrepancyReportAndBankTransactions() {
  yield takeEvery(
    actions.FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchGeneratedPaymentChannelDiscrepancyReportAndBankTransactionsAPI(
          payload,
          pagination,
          roleHeaderAuth
        );

        const result = apiResult.data;
        if (result.success) {
          yield put({
            type: actions.FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            message: result.message,
            filter: payload,
            pagination: result ? result.pagination : null
          });
        } else {
          yield put({
            type: actions.FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS_FAILED,
            loading: false,
            message: result.message
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS_FAILED,
          loading: false,
          message: 'Failed to process request'
        });
      }
    }
  );
}

export function* generatePaymentChannelRemittanceDiscrepancyData() {
  yield takeEvery(
    actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.GENERATING_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield generatePaymentChannelRemittanceDiscrepancyDataAPI(
          payload,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA_SUCCESS,
            loading: false,
            message: result.message
          });

          if (payload && payload?.payment_channel && payload?.posting_date) {
            //wait for 3 seconds before fetching the data
            yield delay(3000);

            yield put({
              type: actions.FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS,
              payload: {
                payment_channel: payload?.payment_channel,
                posting_date: payload?.posting_date
              }
            });
          }
        } else {
          yield put({
            type: actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_DATA_FAILED,
            loading: false,
            message: result.message
          });
        }
      } catch (error) {
        yield put({
          type: actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA_FAILED,
          loading: false,
          message: 'Failed to process request'
        });
      }
    }
  );
}

export function* generatePaymentChannelRemittanceDiscrepancyBreakdownReportFile() {
  yield takeEvery(
    actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.GENERATING_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield generatePaymentChannelRemittanceDiscrepancyBreakdownReportFileAPI(
          payload,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_SUCCESS,
            loading: false,
            message: result.message
          });
        } else {
          yield put({
            type: actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED,
            loading: false,
            message: result.message
          });
        }
      } catch (error) {
        yield put({
          type: actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED,
          loading: false,
          message: 'Failed to process request'
        });
      }
    }
  );
}

export function* downloadGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFile() {
  yield takeEvery(
    actions.DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.DOWNLOADING_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult =
          yield downloadGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileAPI(
            payload,
            roleHeaderAuth
          );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_SUCCESS,
            loading: false,
            message: result.message
          });

          if (result.url) {
            window.open(result.url, '_blank');
          }
        } else {
          yield put({
            type: actions.DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED,
            loading: false,
            message: result.message
          });
        }
      } catch (error) {
        yield put({
          type: actions.DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED,
          loading: false,
          message: 'Failed to process request'
        });
      }
    }
  );
}

export function* fetchAllGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileData() {
  yield takeEvery(
    actions.FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult =
          yield fetchAllGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileDataAPI(
            payload,
            pagination,
            roleHeaderAuth
          );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA_FAILED,
          loading: false
        });
      }
    }
  );
}

export function* fetchRollingReserves() {
  yield takeEvery(actions.FETCH_ROLLING_RESERVES, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_ROLLING_RESERVES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchRollingReservesAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      const finalData = result && result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ROLLING_RESERVES_SUCCESS,
          loading: false,
          result: finalData || result.data,
          pagination: result.pagination,
          filter: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ROLLING_RESERVES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_ROLLING_RESERVES_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null,
            filter: payload
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ROLLING_RESERVES_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null,
        filter: payload
      });
    }
  });
}

export function* updateReconGeneratedReportStatus() {
  yield takeEvery(actions.UPDATE_RECON_GENERATED_REPORT_STATUS, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_RECON_GENERATED_REPORT_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateReconGeneratedReportStatusAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_RECON_GENERATED_REPORT_STATUS_SUCCESS,
          loading: false,
          message: result.message,
          payload: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_RECON_GENERATED_REPORT_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_RECON_GENERATED_REPORT_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_RECON_GENERATED_REPORT_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* checkFilteredRemittanceTransactions() {
  yield takeEvery(actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS, function* ({ payload }) {
    try {
      yield put({
        type: actions.CHECKING_FILTERED_REMITTANCE_TRANSACTIONS,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield checkFilteredRemittanceTransactionsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const mqttPayload = {
        ...payload,
        module: payload?.mqtt_data?.module,
        topic: payload?.mqtt_data?.topic
      };

      yield put({
        type: mqttActions.CONNECT_MQTT,
        payload: mqttPayload
      });

      const event = yield take([mqttActions.CONNECT_SUCCESS]);

      if (event.type !== mqttActions.CONNECT_SUCCESS) {
        yield put({
          type: actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }

      if (result.success) {
        yield put({
          type: actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.trx_date && payload.uploaded_files) {
          const refetchDataObj = {
            remittance_status: payload?.remittance_status,
            date_from: payload?.trx_date?.from,
            date_to: payload?.trx_date?.to,
            payment_channel: payload?.payment_channel,
            selected_files: payload?.uploaded_files,
            payment_channels: payload?.payment_channels ?? []
          };
          yield put({
            type: actions.FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA,
            payload: refetchDataObj
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED,
            message: 'Failed to check filtered transactions',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED,
        loading: false,
        message: 'Failed to check filtered transactions'
      });
    }
  });
}

export function* tagFilteredRemittanceTransactionsAsOffset() {
  yield takeEvery(actions.TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET, function* ({ payload }) {
    try {
      yield put({
        type: actions.TAGGING_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield tagFilteredRemittanceTransactionsAsOffsetAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const mqttPayload = {
        ...payload,
        module: payload?.mqtt_data?.module,
        topic: payload?.mqtt_data?.topic
      };

      yield put({
        type: mqttActions.CONNECT_MQTT,
        payload: mqttPayload
      });

      const event = yield take([mqttActions.CONNECT_SUCCESS]);

      if (event.type !== mqttActions.CONNECT_SUCCESS) {
        yield put({
          type: actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }

      if (result.success) {
        yield put({
          type: actions.TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_SUCCESS,
          loading: false,
          message: result.message
        });

        if (payload && payload.trx_date && payload.uploaded_files) {
          const refetchDataObj = {
            remittance_status: payload?.remittance_status,
            date_from: payload?.trx_date?.from,
            date_to: payload?.trx_date?.to,
            payment_channel: payload?.payment_channel,
            selected_files: payload?.uploaded_files,
            payment_channels: payload?.payment_channel ?? []
          };
          yield put({
            type: actions.FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA,
            payload: refetchDataObj
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_FAILED,
            message: 'Failed to check filtered transactions',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_FAILED,
        loading: false,
        message: 'Failed to check filtered transactions'
      });
    }
  });
}

export function* updateReconciliationRemittanceStatus() {
  yield takeEvery(actions.UPDATE_RECONCILIATION_REMITTANCE_STATUS, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_RECONCILIATION_REMITTANCE_STATUS,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateReconciliationRemittanceStatusAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const mqttPayload = {
        ...payload,
        module: payload?.mqtt_data?.module,
        topic: payload?.mqtt_data?.topic
      };

      yield put({
        type: mqttActions.CONNECT_MQTT,
        payload: mqttPayload
      });

      const event = yield take([mqttActions.CONNECT_SUCCESS]);

      if (event.type !== mqttActions.CONNECT_SUCCESS) {
        yield put({
          type: actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }

      if (result.success) {
        yield put({
          type: actions.UPDATE_RECONCILIATION_REMITTANCE_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_RECONCILIATION_REMITTANCE_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_RECONCILIATION_REMITTANCE_STATUS_FAILED,
            message: 'Failed to check filtered transactions',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_RECONCILIATION_REMITTANCE_STATUS_FAILED,
        loading: false,
        message: 'Failed to check filtered transactions'
      });
    }
  });
}

export function* updateResourceTransactionRemittanceStatus() {
  yield takeEvery(actions.UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS, function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_RESOURCE_TRANSACTION_REMITTANCE_STATUS,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateResourceTransactionRemittanceStatusAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const mqttPayload = {
        ...payload,
        module: payload?.mqtt_data?.module,
        topic: payload?.mqtt_data?.topic
      };

      yield put({
        type: mqttActions.CONNECT_MQTT,
        payload: mqttPayload
      });

      const event = yield take([mqttActions.CONNECT_SUCCESS]);

      if (event.type !== mqttActions.CONNECT_SUCCESS) {
        yield put({
          type: actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }

      if (result.success) {
        yield put({
          type: actions.UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_FAILED,
            message: 'Failed to update resource transaction remittance status',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_FAILED,
        loading: false,
        message: 'Failed to update resource transactions remittance status'
      });
    }
  });
}

export function* fetchUnmatchedTransactions() {
  yield takeEvery(actions.FETCH_UNMATCHED_TRX, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_UNMATCHED_TRX,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUnmatchedTrxAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      const summary = result.data.summary;
      const settings = result.data.unmatched_trx_settings;

      if (result.success) {
        yield put({
          type: actions.FETCH_UNMATCHED_TRX_SUCCESS,
          loading: false,
          result: result.data.data,
          pagination: result.pagination,
          total: result.total,
          summary: summary,
          settings: settings,
          filter: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_UNMATCHED_TRX_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null,
            total: null,
            summary: null,
          });
        } else {
          yield put({
            type: actions.FETCH_UNMATCHED_TRX_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null,
            total: null,
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UNMATCHED_TRX_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null,
        dataCounts: null,
      });
    }
  });
}

export function* getUnmatchedTrxDetails() {
  yield takeEvery('FETCH_UNMATCHED_TRX_DETAILS', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_UNMATCHED_TRX_DETAILS,
      });

      const apiResult = yield getUnmatchedTrxDetailsAPI(payload.payload);
      
      const result = apiResult.data;


      if (apiResult.status === 200) {
        yield put({
          type: actions.FETCH_UNMATCHED_TRX_DETAILS_SUCCESS,
          payload: result.data,
        });
      } else {
        yield put({
          type: actions.FETCH_UNMATCHED_TRX_DETAILS_FAILED,
          error: apiResult.message
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UNMATCHED_TRX_DETAILS_FAILED,
        payload: error
      });
    }
  });
}

export function* processUnmatchedTrxRequestVote() {
  yield takeEvery('PROCESS_UNMATCHED_TRX_REQUEST', function* ({payload, filter}) {
    try {
      yield put({
        type: actions.PROCESSING_UNMATCHED_TRX_REQUEST,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader()

      const apiResult = yield processUnmatchedTrxRequesVoteAPI(payload, roleHeaderAuth)
      const result = apiResult.data

      if (result.success) {
        yield put({
          type: actions.PROCESS_UNMATCHED_TRX_REQUEST_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_UNMATCHED_TRX,
          payload: filter
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.PROCESS_UNMATCHED_TRX_REQUEST_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.PROCESS_UNMATCHED_TRX_REQUEST_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put ({
        type: actions.PROCESS_UNMATCHED_TRX_REQUEST_FAILED,
        message: 'Failed to process request',
        loading: false
      })
      
    }
  }); 
}

export function* endorseUnmatchedTransactions() {
  yield takeEvery('ENDORSE_UNMATCHED_TRX', function* ({payload, filter}) {
    try {
       yield put({
        type: actions.ENDORSING_UNMATCHED_TRX,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader()

      const apiResult = yield endorseUnmatchedTrxsAPI(payload, roleHeaderAuth)
      const result = apiResult.data

      if (result.success) {
        yield put({
          type: actions.ENDORSE_UNMATCHED_TRX_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_UNMATCHED_TRX,
          payload: filter
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ENDORSE_UNMATCHED_TRX_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ENDORSE_UNMATCHED_TRX_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put ({
        type: actions.ENDORSE_UNMATCHED_TRX_FAILED,
        message: 'Failed to process request',
        loading: false
      })
    }

  });
}

export function* updateUnmatchedTrx() {
  yield takeEvery('UPDATE_UNMATCHED_TRX', function* ({payload, filter}) {
    try {
      yield put({
        type: actions.UPDATING_UNMATCHED_TRX,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader()

      const apiResult = yield updateUnmatchedTrxAPI(payload, roleHeaderAuth)
      const result = apiResult.data


      if (result.success) {
        yield put({
          type: actions.UPDATE_UNMATCHED_TRX_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_UNMATCHED_TRX,
          payload: filter
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_UNMATCHED_TRX_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_UNMATCHED_TRX_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch(error) {
      yield put ({
        type: actions.UPDATE_UNMATCHED_TRX_FAILED,
        message: 'Failed to process request',
        loading: false
      })
    }
  })
}

export function* fetchUpdatedTrx() {
  yield takeEvery('FETCH_UPDATED_TRX', function* ({ payload }) {
    try {
      // const pagination = payload.pagination;
      yield put({
          type: actions.FETCHING_UPDATED_TRX,
          loading: true
        });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUpdatedTrxAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_UPDATED_TRX_SUCCESS,
          loading: false,
          result: result.data.data,
          pagination: result ? result.pagination : null,
          filter: payload,
        });
      } else {
        yield put({
          type: actions.FETCH_UPDATED_TRX_FAILED,
          loading: false,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UPDATED_TRX_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}


export function* notifyMerchant() {
  yield takeEvery('NOTIFY_MERCHANT', function* ({payload, filter}) {
    try {
      yield put({
        type: actions.NOTIFYING_MERCHANT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader()

      const apiResult = yield notifyMerchantAPI(payload, roleHeaderAuth)
      const result = apiResult.data


      if (result.success) {
        yield put({
          type: actions.NOTIFY_MERCHANT_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_UPDATED_TRX,
          payload: filter
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.NOTIFY_MERCHANT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.NOTIFY_MERCHANT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch(error) {
      yield put ({
        type: actions.NOTIFY_MERCHANT_FAILED,
        message: 'Failed to process request',
        loading: false
      })
    }
  })
}

export function* fetchUnmatchedTrxLogs() {
  yield takeEvery('FETCH_UNMATCHED_TRX_LOGS', function* ({ payload }) {
    try {
      // const pagination = payload.pagination;
      yield put({
          type: actions.FETCHING_UNMATCHED_TRX_LOGS,
          loading: true
        });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUnmatchedTrxLogsAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_UNMATCHED_TRX_LOGS_SUCCESS,
          loading: false,
          result: result.data.logs,
          pagination: result ? result.data.pagination : null,
          filter: payload,
        });
      } else {
        yield put({
          type: actions.FETCH_UNMATCHED_TRX_LOGS_FAILED,
          loading: false,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UNMATCHED_TRX_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* fetchAssignedApprovers() {
  yield takeEvery(actions.FETCH_ASSIGNED_APPROVERS, function* () {
    try {
      yield put({
        type: actions.FETCHING_ASSIGNED_APPROVERS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAssignedApproversAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ASSIGNED_APPROVERS_SUCCESS,
          loading: false,
          result: result.data,
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ASSIGNED_APPROVERS_FAILED,
            message: result.message,
            loading: false,
          });
        } else {
          yield put({
            type: actions.FETCH_ASSIGNED_APPROVERS_FAILED,
            message: result.message,
            loading: false,
          });
        }
      }

    } catch (error) {
      yield put({
        type: actions.FETCH_ASSIGNED_APPROVERS_FAILED,
        loading: false,
      });
    }

  });
}

export function* manageApproverDepartments() {
  yield takeEvery(actions.MANAGE_APPROVER_DEPARTMENTS, function* ({ payload }) {
    try{
      yield put ({
        type: actions.MANAGING_APPROVER_DEPARTMENTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield manageApproverDepartmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.MANAGE_APPROVER_DEPARTMENTS_SUCCESS,
          loading: false,
          result: result.data,
        });
        yield put({
          type: actions.FETCH_ASSIGNED_APPROVERS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.MANAGE_APPROVER_DEPARTMENTS_FAILED,
            message: result.message,
            loading: false,
          });
        } else {
          yield put({
            type: actions.MANAGE_APPROVER_DEPARTMENTS_FAILED,
            message: result.message,
            loading: false,
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.MANAGE_APPROVER_DEPARTMENTS_FAILED,
        loading: false,
      });
    }
  });
}

export function* fetchExceptionTrx() {
  yield takeEvery(actions.FETCH_EXCEPTION_TRX, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_EXCEPTION_TRX,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchExceptionTrxAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      const summary = result.summary;

      if (result.success) {
        yield put({
          type: actions.FETCH_EXCEPTION_TRX_SUCCESS,
          loading: false,
          result: result.data,
          pagination: result.pagination,
          total: result.total,
          summary: summary,
          // settings: settings,
          filter: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_EXCEPTION_TRX_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null,
            total: null,
            summary: null,
          });
        } else {
          yield put({
            type: actions.FETCH_EXCEPTION_TRX_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null,
            total: null,
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_EXCEPTION_TRX_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null,
        dataCounts: null,
      });
    }
  });
}

export function* fetchBankTemplateByPChannel() {
  yield takeEvery(actions.FETCH_BANK_TEMPLATE_BY_PCHANNEL, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_BANKS_TEMPLATE_BY_PCHANNEL,
        loading: true
      });

      const cache = yield select(
        state => state.Finance.bankTemplateByPChannelCache?.[payload?.payment_channel]
      );

      if (cache) {
        yield put({
          type: actions.FETCH_BANK_TEMPLATE_BY_PCHANNEL_SUCCESS,
          loading: false,
          payment_channel: payload?.payment_channel,
          templates: cache?.templates ?? [],
          message: null
        });
        return;
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchBankTemplateByPChannelAPI(
        payload?.payment_channel,
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_BANK_TEMPLATE_BY_PCHANNEL_SUCCESS,
          loading: false,
          message: result.message,
          payment_channel: payload?.payment_channel,
          templates: result?.data?.templates ?? []
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_BANK_TEMPLATE_BY_PCHANNEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_BANK_TEMPLATE_BY_PCHANNEL_FAILED,
            message: 'Failed to fetch bank templates',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_BANK_TEMPLATE_BY_PCHANNEL_FAILED,
        loading: false,
        message: 'Failed to fetch bank templates'
      });
    }
  });
}

export function* editRemittancePChannelIdentifier() {
  yield takeEvery(actions.EDIT_REMITTANCE_PCHANNEL_IDENTIFIER, function* ({ id, payload }) {
    try {
      yield put({
        type: actions.EDITING_REMITTANCE_PCHANNEL_IDENTIFIER,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editRemittancePChannelIdentifierAPI(id, payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* removePChannelFromTemplateIdentifier() {
  yield takeEvery(actions.REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER, function* ({ id, payload }) {
    try {
      yield put({
        type: actions.REMOVING_REMITTANCE_PCHANNEL_IDENTIFIER,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield removePChannelFromTemplateIdentifierAPI(id, payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addPChannelFromTemplateIdentifier() {
  yield takeEvery(actions.ADD_REMITTANCE_PCHANNEL_IDENTIFIER, function* ({ id, payload }) {
    try {
      yield put({
        type: actions.ADDING_REMITTANCE_PCHANNEL_IDENTIFIER,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addPChannelFromTemplateIdentifierAPI(id, payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateRemittanceReconciliationReport() {
  yield takeEvery(actions.GENERATE_REMITTANCE_RECONCILIATION_REPORT, function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_REMITTANCE_RECONCILIATION_REPORT,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateRemittanceReconciliationReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_REMITTANCE_RECONCILIATION_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_REMITTANCE_RECONCILIATION_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_REMITTANCE_RECONCILIATION_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_REMITTANCE_RECONCILIATION_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadRemittanceReconciliationReport() {
  yield takeEvery(actions.DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT, function* ({ id }) {
    try {
      yield put({
        type: actions.DOWNLOADING_REMITTANCE_RECONCILIATION_REPORT,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadRemittanceReconciliationReportAPI(id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_SUCCESS,
          loading: false,
          message: 'Remittance reconciliation report downloaded successfully.'
        });

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchGeneratedRemittanceReconciliationReport() {
  yield takeEvery(
    actions.FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_GENERATED_REMITTANCE_RECONCILIATION_REPORT,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchGeneratedRemittanceReconciliationReportAPI(
          payload,
          pagination,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null
          });
        } else {
          yield put({
            type: actions.FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT_FAILED,
          loading: false
        });
      }
    }
  );
}



function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}

function uploadFileToS3WithProgress(url, payload, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    // Set up the request
    xhr.open('PUT', url, true);
    xhr.setRequestHeader('Content-Type', payload.file.type);

    xhr.upload.onprogress = function (event) {
      console.log(event);
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        onProgress(percentComplete);
      }
    };

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({
          success: true,
          message: 'File uploaded successfully'
        });
      } else {
        reject({
          success: false,
          message: `Upload failed with status ${xhr.status}`
        });
      }
    };

    xhr.onerror = function () {
      reject({
        success: false,
        message: 'An error occurred during the upload'
      });
    };

    xhr.send(payload.file);
  });
}

async function uploadFileToS3(url, payload) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': payload.file.type
    },
    body: payload.file
  });
}

function addReconciliationMIDSettingAPI(payload, roleAuth) {
  return post(`reconciliation-mid-settings`, payload, null, roleAuth);
}

function fetchReconciliationMIDSettingsAPI(payload, roleAuth) {
  return get(`reconciliation-mid-settings`, payload, null, null, null, roleAuth);
}

function updateReconciliationMIDSettingAPI(payload, roleAuth) {
  return PUT(`reconciliation-mid-settings`, payload, null, null, roleAuth);
}

function fetchPaymentChannelReportsAPI(data, roleAuth) {
  return post(`get/payment-channel-reports`, data, null, null, roleAuth);
}
function fetchPchannelRecordAPI(data, roleAuth) {
  return post(`fetch/payment-channel-record`, data, null, null, roleAuth);
}
function fetchPossibleMatchListAPI(data, roleAuth) {
  return post(`fetch/possible-match-list`, data, null, null, roleAuth);
}
function matchManualTrxAPI(data, roleAuth) {
  return post(`match/manual-trx`, data, null, null, roleAuth);
}
function manualReconcileTrxAPI(data, roleAuth) {
  return post(`match/manual-trx`, data, null, null, roleAuth);
}
function ammendManualTrxAPI(data, roleAuth) {
  return post(`match/manual-trx`, data, null, null, roleAuth);
}
function processReconFileActionAPI(data, roleAuth) {
  return post(`process/recon-file`, data, null, null, roleAuth);
}
function fetchResourceRecordAPI(data, roleAuth) {
  return post(`fetch/resource-record`, data, null, null, roleAuth);
}
function fetchL2DependencyRecordAPI(data, roleAuth) {
  return post(`reconciliation/l2_dependency_record`, data, null, null, roleAuth);
}
function fetchReconFilesAPI(data, roleAuth) {
  return post(`fetch/payment-channel-files`, data, null, null, roleAuth);
}
function fetchReportFilesAPI(data, roleAuth) {
  return post(`fetch/reconciliation-files`, data, null, null, roleAuth);
}
function fetchFilesFromPchannelReportsAPI(data, roleAuth) {
  return post(`get/uploaded-pchannel-report-file`, data, null, null, roleAuth);
}
function generateReportDataAPI(data, roleAuth) {
  return post(`generate/reconciliation-report`, data, null, null, roleAuth);
}

function downloadReconFileAPI(data, roleAuth) {
  return post(`download/reconciliation_report`, data, null, null, roleAuth);
}

function fetchAllRemittanceTemplatesFromPchannelAPI(data, roleAuth) {
  return post(`get/pchannel-remittance-templates`, data, null, null, roleAuth);
}

function addRemittanceTemplateFromPchannelAPI(data, roleAuth) {
  return post(`add/pchannel-remittance-template`, data, null, null, roleAuth);
}

function editRemittanceTemplateFromPchannelAPI(data, roleAuth) {
  return PUT(`edit/pchannel-remittance-template`, data, null, roleAuth);
}

function toggleStatusRemittanceTemplateFromPchannelAPI(data, roleAuth) {
  return PUT(`edit/pchannel-remittance-template-status`, data, null, roleAuth);
}

function uploadMultipleFileDataRemittanceAPI(data, roleAuth) {
  return post(`upload/remittance/upload-multiple-file`, data, null, null, roleAuth);
}

function fetchRemittanceUploadedPchannelDataAPI(data, pagination, roleAuth) {
  return post(`get/pchannel-remittance-uploaded-data`, data, pagination, null, roleAuth);
}

function fetchRemittanceLogsAPI(data, pagination, roleAuth) {
  return post(`get/pchannel-remittance-logs`, data, pagination, null, roleAuth);
}

function fetchFinanceDashboardPchannelDataAPI(data, pagination, roleAuth) {
  return post(`get/finance-dashboard-pchannel-data`, data, pagination, null, roleAuth);
}

function deleteRemittanceFileAndTransactionsAPI(id, roleAuth) {
  return DELETE(`delete/remittance/upload-file/${id}`, null, null, roleAuth);
}

function generateSettlementSummaryReportAPI(data, roleAuth) {
  return post(`settlement/generate-settlement-summary-report`, data, null, roleAuth);
}

function downloadSettlementSummaryReportAPI(id, roleAuth) {
  return get(`download/settlement-summary-report/${id}`, null, null, null, null, roleAuth);
}

function fetchSettlementSummaryReportDataAPI(data, pagination, roleAuth) {
  return post(`get-all/settlement-summary-reports`, data, pagination, null, roleAuth);
}

function requestReviewSettlementReportAPI(data, roleAuth) {
  return post(`request-review/finance-settlement-summary-report`, data, null, null, roleAuth);
}

function approveSettlementSummaryReportAPI(data, roleAuth) {
  return post(`approve/finance-settlement-summary-report`, data, null, null, roleAuth);
}

function rejectSettlementSummaryReportAPI(data, roleAuth) {
  return post(`reject/finance-settlement-summary-report`, data, null, null, roleAuth);
}

function generateSummaryBreakdownReportRemittanceAPI(data, roleAuth) {
  return post(`remittance/generate-summary-breakdown-report`, data, null, roleAuth);
}

function fetchAllGeneratedRemittanceSummaryReportDataAPI(data, pagination, roleAuth) {
  return post(`get-all/generated-remittance-summary-reports`, data, pagination, null, roleAuth);
}

function downloadRemittanceSummaryReportAPI(id, roleAuth) {
  return get(`download-remittance-summary-report/${id}`, null, null, null, null, roleAuth);
}

function deleteRemittanceSummaryReportAPI(id, roleAuth) {
  return DELETE(`delete/remittance/report-file/${id}`, null, null, roleAuth);
}

function downloadUploadedFileRemittanceAPI(data, roleAuth) {
  return post(`download-remittance-uploaded-file`, data, null, null, roleAuth);
}

function fetchGeneratedPaymentChannelDiscrepancyReportAndBankTransactionsAPI(
  data,
  pagination,
  roleAuth
) {
  return post(
    `get/pchannel-remittance-discrepancy-report-and-bank-transactions`,
    data,
    pagination,
    null,
    roleAuth
  );
}

function generatePaymentChannelRemittanceDiscrepancyDataAPI(data, roleAuth) {
  return post(`generate/pchannel-remittance-discrepancy-report`, data, null, null, roleAuth);
}

function generatePaymentChannelRemittanceDiscrepancyBreakdownReportFileAPI(data, roleAuth) {
  return post(
    `generate/pchannel-remittance-discrepancy-breakdown-report-file`,
    data,
    null,
    null,
    roleAuth
  );
}

function downloadGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileAPI(id, roleAuth) {
  return get(
    `download/pchannel-remittance-discrepancy-breakdown-report-file/${id}`,
    null,
    null,
    null,
    null,
    roleAuth
  );
}

function fetchAllGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileDataAPI(
  data,
  pagination,
  roleAuth
) {
  return post(
    `get-all/generated-payment-channel-remittance-breakdown-reports`,
    data,
    pagination,
    null,
    roleAuth
  );
}

// 1️⃣ API calls
function getUploadUrl(files, roleAuth) {
  return post('generate/upload-file-url', files, null, null, roleAuth);
}
function uploadToS3(url, file) {
  return fetch(url, { method: 'PUT', body: file });
}

function parseFiles(body, roleAuth) {
  return post('parse/uploaded-recon-file', body, null, null, roleAuth);
}

function fetchRollingReservesAPI(data, pagination, roleAuth) {
  return post(`get/rolling-reserves`, data, pagination, null, roleAuth);
}

function fetchUnmatchedTrxAPI(payload, roleAuth) {
  return post(`fetch/unmatched_trx`, payload, null, null, roleAuth)
}
function getUnmatchedTrxDetailsAPI(payload, roleAuth) {
  return get(`fetch/unmatched_trx_details`, payload, null, null, null, roleAuth);
}
function processUnmatchedTrxRequesVoteAPI(data, roleAuth) {
  return PUT(`process/unmatched_trx_request_vote`, data, null, roleAuth);
}
function endorseUnmatchedTrxsAPI(payload, roleAuth) {
  return post(`endorse/unmatched_trx_request`, payload, null, null, roleAuth)
}
function updateUnmatchedTrxAPI(payload, roleAuth) {
  return PUT(`update/unmatched-transaction`, payload, null, roleAuth)
}
// function fetchUnmatchedTrxLogsAPI(payload, roleAuth) {
//   return get(
//     `get/unmatched-trx-logs`,
//     payload, //pagination ? pagination : { page: 0, limit: 20 },
//     null,
//     null,
//     null,
//     roleAuth
//   )
// }

function fetchUpdatedTrxAPI(payload, roleAuth) {
  return post('fetch/updated-trx', payload, null, null, roleAuth)
}
function notifyMerchantAPI(payload, roleAuth) {
  return post('send/merchant-notif', payload, null, null, roleAuth)
}
function fetchUnmatchedTrxLogsAPI(payload, roleAuth) {
  return post('get/unmatched-trx-logs', payload, null, null, roleAuth)
}
function fetchAssignedApproversAPI(roleAuth) {
  return get(
     `get/assigned-approvers`,
    null,
    null,
    null,
    null,
    roleAuth
  )
}

function manageApproverDepartmentAPI(data, roleAuth) {
  return post(`manage/approver_departments`, data, null, roleAuth);
}

function fetchExceptionTrxAPI(payload, roleAuth) {
  return post(`fetch/exception_trx`, payload, null, null, roleAuth)
}

function updateReconGeneratedReportStatusAPI(data, roleAuth) {
  return post(`recon-downloadable-files/status`, data, null, roleAuth);
}

function checkFilteredRemittanceTransactionsAPI(data, roleAuth) {
  return post(`check/filtered-transactions`, data, null, null, roleAuth);
}

function tagFilteredRemittanceTransactionsAsOffsetAPI(data, roleAuth) {
  return post(`tag/filtered-transactions-offset`, data, null, null, roleAuth);
}

function updateReconciliationRemittanceStatusAPI (data, roleAuth) {
  return post(`update/reconciliation-transactions-remittance-status`, data, null, null, roleAuth);
}

function updateResourceTransactionRemittanceStatusAPI(data, roleAuth) {
  return post(`update/resource-transactions-remittance-status`, data, null, null, roleAuth);
}

function fetchBankTemplateByPChannelAPI(id, roleAuth) {
  return get(`get/bank-template-payment-channel/${id}`, null, null, null, roleAuth);
}

function editRemittancePChannelIdentifierAPI(id, data, roleAuth) {
  return PUT(`edit/pchannel-remittance-identifier/${id}`, data, null, roleAuth);
}

function removePChannelFromTemplateIdentifierAPI(id, data, roleAuth) {
  return PUT(`remove/pchannel-remittance-identifier/${id}`, data, null, roleAuth);
}

function addPChannelFromTemplateIdentifierAPI(id, data, roleAuth) {
  return PUT(`add/pchannel-remittance-identifier/${id}`, data, null, roleAuth)
}

function generateRemittanceReconciliationReportAPI(data, roleAuth) {
  return post(`generate/remittance-reconciliation-report`, data, null, null, roleAuth);
}

function downloadRemittanceReconciliationReportAPI(id, roleAuth) {
  return get(`download/remittance-reconciliation-report/${id}`, null, null, null, roleAuth);
}

function fetchGeneratedRemittanceReconciliationReportAPI(data, pagination, roleAuth) {
  return post(`get/generated-remittance-reconciliation-reports`, data, pagination, null, roleAuth);
}

export default function* rootSaga() {
  yield all([
    fork(addReconciliationMIDSetting),
    fork(fetchReconciliationMIDSettings),
    fork(updateReconciliationMIDSetting),
    fork(fetchPaymentChannelReportsData),
    fork(fetchPaymentChannelRecord),
    fork(fetchFloatingTrx),
    fork(fetchPossibleMatchList),
    fork(matchManualTrx),
    fork(manualReconcileTrx),
    fork(ammendTrxFloating),
    fork(fetchResourceRecord),
    fork(handleUploadFiles),
    fork(fetchReconFiles),
    fork(fetchReportFiles),
    fork(fetchL2DependencyRecord),
    fork(processReconFileAction),
    fork(generateReportData),
    fork(downloadReconReport),
    fork(fetchFilesFromPchannelReports),
    fork(fetchAllRemittanceTemplatesFromPchannel),
    fork(addRemittanceTemplateFromPchannel),
    fork(editRemittanceTemplateFromPchannel),
    fork(toggleStatusRemittanceTemplateFromPchannel),
    fork(uploadMultipleFileDataRemittance),
    fork(fetchAllUploadedFilesRemittance),
    fork(fetchRemittanceUploadedPchannelData),
    fork(fetchRemittanceLogs),
    fork(fetchFinanceDashboardPchannelData),
    fork(deleteRemittanceFileAndTransactions),
    fork(generateSettlementSummaryReport),
    fork(downloadSettlementSummaryReport),
    fork(fetchSettlementSummaryReportData),
    fork(requestReviewSettlementSummaryReport),
    fork(approveSettlementSummaryReport),
    fork(rejectSettlementSummaryReport),
    fork(generateSummaryBreakdownReportRemittance),
    fork(fetchAllGeneratedRemittanceSummaryReportData),
    fork(downloadRemittanceSummaryReport),
    fork(downloadUploadedFileRemittance),
    fork(fetchGeneratedPaymentChannelDiscrepancyReportAndBankTransactions),
    fork(generatePaymentChannelRemittanceDiscrepancyData),
    fork(generatePaymentChannelRemittanceDiscrepancyBreakdownReportFile),
    fork(downloadGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFile),
    fork(fetchAllGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileData),
    fork(fetchRollingReserves),
    fork(fetchUnmatchedTransactions),
    fork(getUnmatchedTrxDetails),
    fork(processUnmatchedTrxRequestVote),
    fork(endorseUnmatchedTransactions),
    fork(updateUnmatchedTrx),
    fork(fetchUnmatchedTrxLogs),
    fork(fetchUpdatedTrx),
    fork(notifyMerchant),
    fork(fetchAssignedApprovers),
    fork(manageApproverDepartments),
    fork(fetchExceptionTrx),
    fork(updateReconGeneratedReportStatus),
    fork(checkFilteredRemittanceTransactions),
    fork(tagFilteredRemittanceTransactionsAsOffset),
    fork(updateReconciliationRemittanceStatus),
    fork(fetchBankTemplateByPChannel),
    fork(editRemittancePChannelIdentifier),
    fork(removePChannelFromTemplateIdentifier),
    fork(addPChannelFromTemplateIdentifier),
    fork(generateRemittanceReconciliationReport),
    fork(downloadRemittanceReconciliationReport),
    fork(fetchGeneratedRemittanceReconciliationReport),
    fork(updateResourceTransactionRemittanceStatus)
  ]);
}
